module.exports = __webpack_public_path__ + "static/img/ly-marketing.f93c7df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ly-marketing.svg
// module id = X8vn
// module chunks = 16